import { Controller } from "@hotwired/stimulus";
import { DisplayMode } from "../../scripts/_generated/DisplayMode";

export default class AudioPlayerController extends Controller {
    static targets = ['playButton', 'pauseButton', 'audioElement'];
    static values = {
        displayMode: Number
    };

    readonly playButtonTarget!: HTMLElement;
    readonly pauseButtonTarget!: HTMLElement;
    readonly audioElementTarget!: HTMLAudioElement;

    readonly displayModeValue!: DisplayMode;

    connect() {
        this.audioElementTarget.onended = () => this.pause();
    }

    play() {
        $(this.playButtonTarget).hide();
        if (this.displayModeValue === DisplayMode.MiniInplace) {
            $(this.pauseButtonTarget).show();
        }
        else {
            $(this.audioElementTarget).show();
        }

        this.audioElementTarget.play();
    }

    pause() {
        if (this.displayModeValue !== DisplayMode.Full) {
            $(this.playButtonTarget).show();
        }
        if (this.displayModeValue === DisplayMode.MiniInplace) {
            $(this.pauseButtonTarget).hide();
        }
        if (!this.audioElementTarget.ended) {
            this.audioElementTarget.pause();
        }
    }
}
